
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"111","height":"107","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M77.468 56.68a29.49 29.49 0 00-5.406 4.578l-14.85-45.865a6.106 6.106 0 00-9.208-3.151c-.309.204-.6.435-.87.689L10.647 47.786a6.106 6.106 0 00-.716 8.198l16.17 39.54c.131.271.28.534.445.786 3.054 4.629 10.91 4.828 17.55.445 6.64-4.384 9.544-11.688 6.49-16.316-3.053-4.63-10.909-4.828-17.549-.445a20.168 20.168 0 00-3.695 3.135l-6.946-21.453c.179-.095.347-.192.513-.302a6.36 6.36 0 00.862-.683l27.271-26.372 16.283 45.07c.192.396.41.78.65 1.147 4.467 6.769 15.956 7.06 25.665.65 9.709-6.409 13.959-17.087 9.495-23.851-4.465-6.764-15.958-7.069-25.666-.656z","fill":"#9C227D"}})])
          )
        }
      }
    